<!-- If image -->
<div
	class="image"
	[class.visible]="src"
	[ngStyle]="src ? { 'background-image': 'url(' + src + ')' } : {}"
></div>

<!-- If no image -->
<i *ngIf="showIcon" [class]="emptyIcon"></i>
